import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row } from 'react-flexbox-grid';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined, DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as Constants from '../../../constants';
import { storage } from '../../../config/Fire';
import './styles.css';

const antIcon = <LoadingOutlined type="loading" spin/>;

const ChatMessage = props => {
    const[imagePath, setImagePath] = useState("")
    const[modalImageVisible, setModalImageVisible] = useState(false)
    const[downloadingFile, setDownloadingFile] = useState(false)
    const linkFileRef = useRef(null)

    const renderDateFormat = date => {
        return moment(date, "HH:mm:ss DD/MM/YYYY").format("HH:mm DD/MM/YYYY")
    }

    const isMyMessage = (senderId, clientId, myId) => {
        if (myId === senderId) {
            return true
        } else {
            return (senderId !== clientId && myId !== clientId)
        }
    }

    const loadImagePath = imagePathStorage => {
        if(imagePath === "") {
            console.log("loadImagePath")
            storage.ref().child(imagePathStorage).getDownloadURL().then(url => {
                setImagePath(url)
            });
        }
    }

    const getFileName = path => {
        const filePathSplited = path.split("/")
        var fileName = ""
        if (filePathSplited.length > 0) {
            fileName = filePathSplited[filePathSplited.length - 1]
        } else {
            fileName = "Archivo adjunto"
        }
        return fileName
    }

    const downloadFile = filePathStorage => {
        setDownloadingFile(true)
        console.log("downloadFile...")
        storage.ref().child(filePathStorage).getDownloadURL()
        .then(url => {
            console.log("File url")
            /*var xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = function(event) {
                var blob = xhr.response;
            }
            xhr.open("GET", url);
            xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
            xhr.setRequestHeader('Access-Control-Allow-Methods', 'PUT, GET, POST, DELETE, OPTIONS');
            xhr.setRequestHeader('Access-Control-Allow-Headers', 'Content-Type');
            xhr.send();
            console.log(url)*/
            if(linkFileRef && linkFileRef.current) {
                linkFileRef.current.href = url
                linkFileRef.current.click();
                linkFileRef.current.remove();
                setDownloadingFile(false)
            }
        })
        .catch(err => {
            console.log("download file error: " + JSON.stringify(err))
            message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
        })
    }

    const renderMyChatMessageComponent = messageType => {
        switch (messageType) {
            case Constants.messageType.TEXT:
                return (<Row className="chatMessageBubble" end="xs">
                            <div className="myMessage">
                                <p className="chatMessageText">{props.chatMessage.message}</p>
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                            </div>
                        </Row>);
            case Constants.messageType.IMAGE:
                return (<Row className="chatMessageBubble" end="xs">
                            <div className="myMessageImage" onClick={() => imagePath !== "" && setModalImageVisible(true)}>
                                {
                                    imagePath === "" ?
                                        <Spin className="chatMessageImageLoading" size="large" indicator={antIcon} />
                                        :
                                        <img className="chatMessageImage" src={imagePath} alt="Grupo SADE"/>
                                }
                                {loadImagePath(props.chatMessage.imagePath)}
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                            </div>
                        </Row>);
            case Constants.messageType.FILE:
                return (<Row className="chatMessageBubble" end="xs">
                            <div className={`myMessageFile${downloadingFile ? "Downloading" : ""}`} onClick={() => downloadingFile === false && downloadFile(props.chatMessage.filePath)}>
                                <p className="chatMessageText">{ downloadingFile ? <LoadingOutlined /> : <DownloadOutlined />} {getFileName(props.chatMessage.filePath)}</p>
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                                <a ref={linkFileRef} className="chatMessageFileLink" href="" download/>
                            </div>
                        </Row>);
        
            default:
                return (<Row className="chatMessageBubble" end="xs">
                            <div className="myMessage">
                                <p className="chatMessageText">{props.chatMessage.message}</p>
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                            </div>
                        </Row>);
        }
    }

    const renderHisChatMessageComponent = messageType => {
        switch (messageType) {
            case Constants.messageType.TEXT:
                return (<Row className="chatMessageBubble" start="xs">
                            <div className="hisMessage">
                                <p className="chatMessageText">{props.chatMessage.message}</p>
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                            </div>
                        </Row>);
            case Constants.messageType.IMAGE:
                return (<Row className="chatMessageBubble" start="xs">
                            <div className="hisMessageImage" onClick={() => imagePath !== "" && setModalImageVisible(true)}>
                                {
                                    imagePath === "" ?
                                        <Spin className="chatMessageImageLoading" size="large" indicator={antIcon} />
                                        :
                                        <img className="chatMessageImage" src={imagePath} alt="Grupo SADE"/>
                                }
                                {loadImagePath(props.chatMessage.imagePath)}
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                            </div>
                        </Row>);
            case Constants.messageType.FILE:
                return (<Row className="chatMessageBubble" start="xs">
                            <div className={`hisMessageFile${downloadingFile ? "Downloading" : ""}`} onClick={() => downloadingFile === false && downloadFile(props.chatMessage.filePath)}>
                                <p className="chatMessageText">{getFileName(props.chatMessage.filePath)} { downloadingFile ? <LoadingOutlined /> : <DownloadOutlined />}</p>
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                                <a ref={linkFileRef} className="chatMessageFileLink" href="" download/>
                            </div>
                        </Row>);
        
            default:
                return (<Row className="chatMessageBubble" start="xs">
                            <div className="hisMessage">
                                <p className="chatMessageText">{props.chatMessage.message}</p>
                                <p className="chatMessageDate">{renderDateFormat(props.chatMessage.sendedDate)}</p>
                            </div>
                        </Row>);
        }
    }

    return (
        <Grid className="chatMessageContainer">
            {
                isMyMessage(props.chatMessage.senderId, props.clientId, props.userId) ?
                    renderMyChatMessageComponent(props.chatMessage.messageType)
                    :
                    renderHisChatMessageComponent(props.chatMessage.messageType)
            }
            <Modal visible={modalImageVisible} footer={null} onCancel={() => setModalImageVisible(false)}>
                <img alt="images" style={{ width: '100%' }} src={imagePath} />
            </Modal>
        </Grid>
    );
};

ChatMessage.propTypes = {
    chatMessage: PropTypes.object.isRequired,
    userId: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired,
};

export default ChatMessage;